/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".wrapper[_ngcontent-%COMP%]{margin-top:3rem;margin-bottom:3rem}.select-project[_ngcontent-%COMP%]{display:flex;width:100%}.select-project[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{font-weight:800;width:200px;flex-shrink:0}.field-select[_ngcontent-%COMP%]{flex:1}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/access-management/project-comittee-handler/project-comittee-handler.component.scss.shim.ngstyle.js.pre-build-optimizer.js